import URLSearchParams from '@ungap/url-search-params';

const searchLangcodeRegex = new RegExp("^/?[a-z]{2}/");

export function url(path, getParams) {

  if (!path) {
    return '';
  }

  const startingSlash = () => {
    if (path[0] === '/') {
      return '';
    } else {
      return '/';
    }
  };

  const languageDir = () => {
    if (jsVar('language') && path.search(searchLangcodeRegex) === -1) {
      return jsVar('language') + '/';
    } else {
      return '';
    }
  };

  if (path.indexOf('?') > -1) {

    const getParamStr = path.split('?')[1];
    path = path.split('?')[0];
    const existingGetParams = new URLSearchParams(getParamStr);
    if (!getParams) getParams = {};

    existingGetParams.forEach((value, key) => {
      getParams[key] = value;
    });

  }

  const queryString = () => {
    if (getParams) {
      return '?' + makeQueryString(getParams);
    } else {
      return '';
    }
  };

  if (path === '/') {
    return '/' + languageDir();
  }

  return startingSlash() + languageDir() + path + queryString();

}

export function isValidUrl(url) {
  var pattern = /((localhost)|([-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}))\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
  return url.match(pattern);
}

export function absoluteUrl(path, getParams) {
  return window.location.origin + url(path, getParams);
}

export function getQueryParam(name) {
  const params = new URLSearchParams(window.location.search);
  return params.get(name);
}

/**
 * Returns an new version of the current querystring, updated with `params`.
 *
 * - Will parse `window.location.search` and update it with the given `params`
 *   and convert it back to a string.
 * - If you pass `null` as a value to a param, then the param will be removed
 *   if it is currently present, or ignored otherwise.
 * - If there are no params present after the update, this function returns an
 *   empty string.
 * - If this function returns a non-empty querystring, it will always start
 *   with a leading `?`.
 */
export function updateQueryString(params) {

  const origParams = new URLSearchParams(window.location.search);

  for (const [key, value] of Object.entries(params)) {
    if (value === null) {
      origParams.delete(key);
    } else {
      origParams.set(key, value);
    }
  }

  const queryString = origParams.toString();

  if (queryString) {
    return '?' + queryString;
  } else {
    return '';
  }

}

export function makeQueryString(params) {
  if (params) {
    return (new URLSearchParams(params)).toString();
  }
}

export function stripLangFromPath(path) {
  if (path.match('^/[a-z][a-z]/')) {
    return path.substring(4);
  } else {
    return path;
  }
}
